import { Component, Input, OnInit } from "@angular/core";
import { RealTimeService } from "../../main/common/notifications/real-time.service";
import { ConversationsService } from "../conversations.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { AutosizeModule } from "ngx-autosize";
import { FormsModule } from "@angular/forms";
import { MessageBubbleComponent } from "../message-bubble/message-bubble.component";
import { NgIf, NgFor } from "@angular/common";

@Component({
    selector: "ch-client-task-comments",
    templateUrl: "./client-task-comments.component.html",
    styleUrls: ["./client-task-comments.component.scss"],
    imports: [
        NgIf,
        NgFor,
        MessageBubbleComponent,
        FormsModule,
        AutosizeModule,
    ]
})
export class ClientTaskCommentsComponent implements OnInit {
  @Input() trackedItem = null;
  user: any = null;
  isSendingComment = false;

  constructor(
    private localStorageService: LocalStorageService,
    private realTimeService: RealTimeService,
    private conversationsService: ConversationsService
  ) {}

  ngOnInit(): void {
    this.user = this.localStorageService.get("user");
  }

  ngOnChanges(changes: any): void {
    if (changes.trackedItem) {
      this.trackedItem = changes.trackedItem.currentValue;
      this.refreshTrackedItemComments();
      this.listenForTrackedItemComments();
    }
  }

  listenForTrackedItemComments() {
    if (!this.trackedItem) {
      this.realTimeService.unsetTrackedItemCommentsListener();
      return;
    }

    this.realTimeService.setTrackedItemCommentsListener(this.trackedItem?.uuid);
    this.realTimeService.trackedItemComments.subscribe((message: any) => {
      if (message?.message) this.addComment(message);
      else this.refreshTrackedItemComments();
    });
  }

  refreshTrackedItemComments() {
    if (!this.trackedItem) return;

    console.log("Refreshing comments", this.trackedItem);
    this.conversationsService
      .getTrackedItemComments(this.trackedItem?.id)
      .subscribe(
        (res) => (this.trackedItem.comments = res),
        (err) => console.error(err.error.message)
      );
  }

  mockComment(hash: string, text: string) {
    const message: any = {};
    message.uuid = hash;
    message.comment = null;
    message.date = null;
    message.edit_mode = false;
    message.edited = false;
    message.file = null;
    message.message = text;
    message.meta = {};
    message.pinned = false;
    message.reminder = null;
    message.reminder_creator = null;
    message.replyingTo = null;
    message.sent_by = this.user;
    message.system_message = false;
    message.tracked_item = this.trackedItem;

    return message;
  }

  addComment(comment: any) {
    const idx = this.trackedItem.comments.findIndex(
      (c: any) => c.uuid == comment.uuid
    );
    if (idx > -1) this.trackedItem.comments[idx] = comment;
    else this.trackedItem.comments.push(comment);
  }

  setCommentAsSent(hash: string, comment: any) {
    const idx = this.trackedItem.comments.findIndex((c: any) => c.uuid == hash);
    this.trackedItem.comments[idx] = comment;
  }

  send_comment(message, tracked_item_id, input): void {
    input.value = "";
    if (message.trim() != "" && !this.isSendingComment) {
      this.isSendingComment = true;
      const hash = Math.random().toString(36).substring(7);
      this.trackedItem.comments.push(this.mockComment(hash, message));
      this.conversationsService
        .comment_tracked_item(tracked_item_id, message)
        .then((res: any) => {
          message = "";
          this.isSendingComment = false;
          this.setCommentAsSent(hash, res);
          setTimeout(() => {
            input.focus();
          }, 100);
        })
        .catch((err) => {
          this.isSendingComment = false;
        });
    }
  }
}
